import { Brand } from "../../components/Brand";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../lib/api";
import { Button, Field } from "../../components/ui";
import { useAuth } from "./AuthProvider";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [totp, setTotp] = useState("");
  const [needsTotp, setNeedsTotp] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email.trim(), password, needsTotp ? totp.trim() : undefined);
      navigate("/securities", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && /2FA requis/i.test(err.message)) {
        setNeedsTotp(true);
        setError("Saisissez le code de votre application d’authentification.");
      } else {
        setError(err instanceof Error ? err.message : "Échec de connexion");
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <Brand suffix="Admin" className="login-brand" />
        <Field
          label="Email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <Field
          label="Mot de passe"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {needsTotp && (
          <Field
            label="Code 2FA"
            inputMode="numeric"
            maxLength={6}
            value={totp}
            onChange={(e) => setTotp(e.target.value)}
            required
          />
        )}
        {error && <p className="error-text">{error}</p>}
        <Button type="submit" disabled={busy}>
          {busy ? "Connexion…" : "Se connecter"}
        </Button>
      </form>
    </div>
  );
}
